import Dexie, { type EntityTable, type Table } from 'dexie';
import type { LocalNote } from '@/domain/note';

export interface MetaEntry {
  key: string;
  value: string;
}

/** Local offline database (IndexedDB). */
export class TagnDB extends Dexie {
  notes!: EntityTable<LocalNote, 'id'>;
  meta!: Table<MetaEntry, string>;

  constructor(name = 'tagn') {
    super(name);
    this.version(1).stores({
      notes: 'id, updatedAt, dirty',
      meta: 'key',
    });
  }

  async getMeta(key: string): Promise<string | undefined> {
    return (await this.meta.get(key))?.value;
  }

  async setMeta(key: string, value: string): Promise<void> {
    await this.meta.put({ key, value });
  }

  /** Removes all local data (logout). */
  async wipe(): Promise<void> {
    await this.transaction('rw', this.notes, this.meta, async () => {
      await this.notes.clear();
      await this.meta.clear();
    });
  }
}

export const db = new TagnDB();
